import { Navigate, Route, useParams, useSearchParams } from 'react-router';

import { legacyRoutes } from '@/constants/legacyRoutes';
import { routes } from '@/constants/routes';
import {
  NewProjectExpense,
  EditProjectExpense,
} from '@/pages/projects/expenses';
import { EditExpense, NewExpense } from '@/pages/register/expenses';

const ExpenseEditRedirect = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <Navigate to={routes.register.expenses.new()} replace />;
  }

  return <Navigate to={routes.register.expenses.edit(id)} replace />;
};
const ProjectExpenseEditRedirect = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <Navigate to={routes.projects.expenses.new()} replace />;
  }

  return <Navigate to={routes.projects.expenses.edit(id)} replace />;
};

const NewPersonalExpenseRedirect = () => {
  const [searchParams] = useSearchParams();

  const employeeUserId = searchParams.get('employeeUserID');
  const projectId = searchParams.get('projectID');
  const date = searchParams.get('date');

  const queryString = new URLSearchParams({
    ...(employeeUserId ? { employeeUserId } : {}),
    ...(projectId ? { projectId } : {}),
    ...(date ? { date } : {}),
  }).toString();
  return (
    <Navigate
      to={`${routes.register.expenses.new()}${queryString ? `?${queryString}` : ''}`}
      replace
    />
  );
};

const NewProjectExpenseRedirect = () => {
  const [URLSearchParams] = useSearchParams();

  const projectId = URLSearchParams.get('projectID');
  const projectSubContractId = URLSearchParams.get('projectSubContractID');

  if (!projectId && !projectSubContractId) {
    return <Navigate to={routes.projects.expenses.new()} replace />;
  }

  if (projectId && !projectSubContractId) {
    return (
      <Navigate to={routes.projects.expenses.newWithId(projectId)} replace />
    );
  }

  if (projectId && projectSubContractId) {
    return (
      <Navigate
        to={`${routes.projects.expenses.newWithId(
          projectId,
        )}?contractId=${projectSubContractId}`}
        replace
      />
    );
  }

  return <Navigate to={routes.projects.expenses.new()} replace />;
};

export const ExpenseFaceliftRouter = () => {
  return [
    <Route
      key="register-expenses-new"
      path={routes.register.expenses.new()}
      element={<NewExpense />}
    />,

    <Route
      key="register-expenses-edit"
      path={routes.register.expenses.edit(':id')}
      element={<EditExpense />}
    />,

    <Route
      key="projects-expenses-new"
      path={routes.projects.expenses.new()}
      element={<NewProjectExpense />}
    />,

    <Route
      key="project-expenses-new"
      path={routes.projects.expenses.newWithId(':id')}
      element={<NewProjectExpense />}
    />,

    <Route
      key="project-expenses-edit"
      path={routes.projects.expenses.edit(':id')}
      element={<EditProjectExpense />}
    />,

    /*  Redirect handling for legacy expense UI */
    <Route
      key="register-expenses-legacy-redirect"
      path={legacyRoutes.registration.employeeExpense.new()}
      element={<NewPersonalExpenseRedirect />}
    />,

    <Route
      key="register-expenses-legacy-edit-redirect"
      path={legacyRoutes.registration.employeeExpense.edit(':id')}
      element={<ExpenseEditRedirect />}
    />,

    <Route
      key="project-expenses-new-legacy-redirect"
      path={legacyRoutes.projectManagement.projectExpenses.new()}
      element={<NewProjectExpenseRedirect />}
    />,

    <Route
      key="project-expenses-edit-legacy-redirect"
      path={legacyRoutes.projectManagement.projectExpenses.edit(':id')}
      element={<ProjectExpenseEditRedirect />}
    />,
  ];
};
